import * as React from 'react';

import * as styles from './FloorFilterWrapper.css';

interface IFloorFilterWrapperProps {
  floorInput: React.ReactNode;
  floorType: React.ReactNode;
}

export const FloorFilterWrapper: React.FC<IFloorFilterWrapperProps> = ({ floorInput, floorType }) => {
  return (
    <div className={styles['container']}>
      <div data-testid="FloorInputContainer" className={styles['input']}>
        {floorInput}
      </div>
      {floorType}
    </div>
  );
};
